<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'BaseMn',
  data () {
    return {
      pageMstr: {},
      pageParams: {},
      upMstr: {},
      mnMstr: {},
      timer: false,
      fullHeight: document.documentElement.clientHeight,
      fullWidth: document.documentElement.clientWidth,
      timerWidth: false,
      bTabPaneHeight: 0,
      dTabPaneHeight: 0,
      passData: {},
      passFormRules: {
        pageMnPass: [
          { required: true, message: this.$t('form.UdfQueryJs.verificationCodeEmpty'), trigger: 'blur' }
        ]
      },
      pageShow: ''
    }
  },
  computed: {
    ...mapState('pageHeight', ['mainHeight', 'sideHeight', 'containerHeight', 'tabHeight', 'mtableHeight', 'dtableHeight']),
    constObj_ () {
      const that = this
      return {
        APP: that.app_,
        SITE: that.site_,
        HRSITE: that.hrSite_,
        EAMSITE: that.eamSite_,
        USER: that.uuId_,
        UNAME: that.uuName_,
        UDEPT: that.uuDept_,
        UDEPTNAME: that.uuDeptName_,
        LANG: that.lang_,
        MNID: that.mnId_,
        MODIFYALL: that.modyfyAll_,
        LASTYEAR: that.$Any.toInt(that.$Any.getCurrentDate('Y')) - 1,
        THISYEAR: that.$Any.toInt(that.$Any.getCurrentDate('Y')),
        NEXTYEAR: that.$Any.toInt(that.$Any.getCurrentDate('Y')) + 1,
        LASTMONTH: that.$Any.toInt(that.$Any.getCurrentDate('M')) - 1,
        THISMONTH: that.$Any.toInt(that.$Any.getCurrentDate('M')),
        NEXTMONTH: that.$Any.toInt(that.$Any.getCurrentDate('M')) + 1,
        TODAY: that.$Any.getCurrentDate('yyyy-MM-dd'),
        THISTIME: that.$Any.getCurrentDate('yyyy-MM-dd HH:mm')
      }
    },
    lang_ () {
      return localStorage.getItem('lang')
    },
    site_ () {
      return window.sessionStorage.getItem('currentSite')
    },
    hrSite_ () {
      return window.sessionStorage.getItem('currentHrSite')
    },
    eamSite_ () {
      return window.sessionStorage.getItem('currentEamSite')
    },
    defApp_ () {
      return window.sessionStorage.getItem('defApp')
    },
    app_ () {
      if (this.mnMstr) {
        return this.mnMstr.mnApp
      } else {
        return ''
      }
    },
    modyfyAll_ () {
      if (this.upMstr) {
        if (this.upMstr.upModifyAll) {
          return 1
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    mnId_ () {
      return this.pageParams.id
    },
    uuId_ () {
      return window.sessionStorage.getItem('currentUserCode')
    },
    uuName_ () {
      return window.sessionStorage.getItem('currentUserName')
    },
    uuDept_ () {
      return window.sessionStorage.getItem('currentUserDept')
    },
    uuDeptName_ () {
      return window.sessionStorage.getItem('currentUserDeptName')
    }
  },
  methods: {
    ...mapMutations('pageHeight', ['setMainHeight', 'setSideHeight', 'setContainerHeight', 'setTabHeight', 'setMtableHeight', 'setDtableHeight']),
    getPaneHeight (navHeight) {
      this.bTabPaneHeight = window.innerHeight - 40 - 30 - 29 - navHeight
    },
    loadUpMstr: async function () {
      const that = this
      const menuId = that.pageParams.id
      const para = {
        site: that.site_,
        mn: menuId
      }
      const { data: res } = await that.$http.post('/users/getUserMnUp', para)
      that.upMstr = res.data[0]
    },
    loadMnMstr: async function () {
      const that = this
      const menuId = that.pageParams.id
      const para = {
        mnMenuId: menuId
      }
      const { data: res } = await that.$http.post('/users/getMnMstrById', para)
      that.mnMstr = res.data
    },
    getBodyHeight () {
      const that = this
      const innerHeight = window.innerHeight
      const cHeight = window.innerHeight - 40
      const pHeight = window.innerHeight - 40 - 31
      that.setMainHeight(innerHeight)
      that.setSideHeight(innerHeight)
      that.setContainerHeight(cHeight)
      that.setTabHeight(pHeight)
      if ((that.pageType) && (that.pageType === 'BASE')) {
        const navHeight = that.$refs.editslot.$refs.navtools.offsetHeight
        const panelHeight = innerHeight - 40 - 30 - 29 - navHeight
        that.setMtableHeight(panelHeight)
        that.$refs.mainGrid.doLayout()
        if ((that.$refs.editslot.activeTab === 'detail_second') && (that.hasDetGrid)) {
          const navdetHeight = that.$refs.editslot.$refs.navdettools.offsetHeight
          that.getDtableHeight(navdetHeight)
        }
        if (that.$refs.editslot.activeTab === 'tab_fifth') {
          const btnHeight = that.$refs.editslot.$refs.utkBtnGroup.offsetHeight
          that.$refs.editslot.flowHeight = that.mtableHeight - btnHeight
        }
      }
      window.onresize = () => {
        return (() => {
          const that = this
          const innerHeight = window.innerHeight
          const cHeight = window.innerHeight - 40
          const pHeight = window.innerHeight - 40 - 31
          that.setMainHeight(innerHeight)
          that.setSideHeight(innerHeight)
          that.setContainerHeight(cHeight)
          that.setTabHeight(pHeight)
          if ((that.pageType) && (that.pageType === 'BASE')) {
            const navHeight = that.$refs.editslot.$refs.navtools.offsetHeight
            const panelHeight = innerHeight - 40 - 30 - 29 - navHeight
            that.setMtableHeight(panelHeight)
            that.$refs.mainGrid.doLayout()
            if ((that.$refs.editslot.activeTab === 'detail_second') && (that.hasDetGrid)) {
              const navdetHeight = that.$refs.editslot.$refs.navdettools.offsetHeight
              that.getDtableHeight(navdetHeight)
            }
            if (that.$refs.editslot.activeTab === 'tab_fifth') {
              const btnHeight = that.$refs.editslot.$refs.utkBtnGroup.offsetHeight
              that.$refs.editslot.flowHeight = that.mtableHeight - btnHeight
            }
          }
        })()
      }
    },
    loadPageCheck: async function () {
      const that = this
      const para = {
        pageMnId: that.pageParams.id
      }
      const { data: res } = await this.$http.post('/users/getPageCheckMstrShow', para)
      if (res.data) {
        that.passData = res.data
        that.pageShow = 'Check'
      } else {
        that.pageShow = 'Base'
      }
    },
    passCheck () {
      const that = this
      that.$refs.passFormRef.validate(async (valid) => {
        if (valid) {
          const para = that.passData
          para.pageUser = that.uuId_
          const { data: res } = await this.$http.post('/users/CheckPageMnPass', para)
          if (res.data) {
            that.pageShow = 'Base'
          } else {
            that.pageShow = 'Check'
            that.$message(this.$t('form.UdfQueryJs.verificationCodeError'))
          }
        } else {
          return false
        }
      })
    }
  },
  mounted () {
    const that = this
    that.$nextTick(function () {
      that.getBodyHeight()
    })
  },
  watch: {
    pageShow () {
      const that = this
      that.$nextTick(function () {
        that.getBodyHeight()
      })
    }
    // fullHeight (val) {
    //   if (!this.timer) {
    //     this.fullHeight = val
    //     this.timer = true
    //     const that = this
    //     setTimeout(function () {
    //       that.timer = false
    //     }, 400)
    //   }
    // },
    // fullWidth (val) {
    //   if (!this.timerWidth) {
    //     this.fullWidth = val
    //     this.timerWidth = true
    //     const that = this
    //     setTimeout(function () {
    //       that.timerWidth = false
    //     }, 400)
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>

</style>
